import React, { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";
import { LiebherrGeneratorEngine } from "./liebherr-generatorEngine";
import { LiebherrMairneEngine } from "./liebherr-marineEngine";
export interface Props {setData : Function}
export const Liebherr:React.FC<Props> = ({setData}) => {
    const location = useLocation()
    const path = location.pathname.split('/')
    useLayoutEffect(()=>{
        switch(path[2]){
            case 'marineEngine' : setData((prev:any)=>({...prev, title_2_kr : '선박용 엔진', title_2_en : 'Marine Engine', className_2 : 'engine_view'})); break;
            case 'generatorEngine' : setData((prev:any)=>({...prev, title_2_kr : '발전기 엔진', title_2_en : 'Generator Engine', className_2 : 'generator_engine'})); break;
        }
    }, [location])
    return(
        <>
        {path[2]==='marineEngine'?<LiebherrMairneEngine/> : ''}
        {path[2]==='generatorEngine'?<LiebherrGeneratorEngine/> : ''}
        </>
    )
}